/* eslint-disable import/no-cycle */
import styled from '@emotion/styled';
import usePaymentMethods from '@hooks/usePaymentMethods';
import { Fonts } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import React, { useEffect } from 'react';

export const QRExpiryTime = 600; // This is in seconds

const Timer = () => {
  const {
    state: {
      order,
      isCreatingOrder,
      setOrder,
      setOrderExpired,
      orderExpired,
      setQRExpiryTime,
      qRExpiryTime,
      generateQRClicked,
      setGenerateQRClicked
    }
  } = usePaymentMethods();

  useEffect(() => {
    if (!isCreatingOrder) setQRExpiryTime(QRExpiryTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreatingOrder]);

  useEffect(() => {
    if (order) {
      if (qRExpiryTime <= 0) {
        handleTimerEnd();
        return;
      }
      const interval = setInterval(() => {
        setQRExpiryTime((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qRExpiryTime, order]);

  const handleTimerEnd = () => {
    setOrder(null);
    setGenerateQRClicked(false);
    setOrderExpired(true);
    setQRExpiryTime(QRExpiryTime);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`;
  };

  const timerTagUI = () => {
    formatTime(qRExpiryTime);
    return (
      <span>
        <span style={{ color: 'var(--color-i-gray-13)' }}>QR is valid for</span>{' '}
        <span style={{ color: 'var(--color-i-red)' }}>
          {formatTime(qRExpiryTime)}
        </span>{' '}
        <span style={{ fontWeight: Fonts.SEMIBOLD }}>minutes</span>
      </span>
    );
  };

  const getQRText = () => {
    if (orderExpired && generateQRClicked)
      return 'QR has expired. Please retry.';
    if (isCreatingOrder && generateQRClicked) return 'Generating QR...';
    if (!order || !generateQRClicked) return 'Generate a new QR to scan';
    return timerTagUI();
  };

  return (
    <div>
      <Typography variant="p2">{getQRText()}</Typography>
    </div>
  );
};

export default Timer;
